import { render, staticRenderFns } from "./BoxInspections.vue?vue&type=template&id=78918e6a"
import script from "./BoxInspections.vue?vue&type=script&lang=js"
export * from "./BoxInspections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports